import { z } from 'zod';

export const createSubscriptionByAdminSchema = z.object({
  user_id: z.uuid(),
  subscription_type: z.enum(['pro-trial', 'pro']),
  start_at: z.string().datetime(),
  end_at: z.string().datetime(),
});

export type CreateSubscriptionByAdminPayload = z.infer<typeof createSubscriptionByAdminSchema>;
